import { render, staticRenderFns } from "./shipments-overview.vue?vue&type=template&id=1dbface3&scoped=true"
import script from "./shipments-overview.vue?vue&type=script&lang=js"
export * from "./shipments-overview.vue?vue&type=script&lang=js"
import style0 from "./shipments-overview.vue?vue&type=style&index=0&id=1dbface3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbface3",
  null
  
)

export default component.exports